import React from 'react';

import './ProductItemShippingCallout.scss';

function ProductItemShippingCallout () {

	return (
		<div className="ProductItemShippingCallout">
			<span>Free Shipping*</span>
		</div>
	);

}

export default ProductItemShippingCallout;
